import type { Issue } from "./readerApi";

interface Props {
  /** The issues about the quotation as a whole -- its supplier, its totals --
   * rather than about one line, which sit under their lines. */
  issues: Issue[];
  /** The office has overridden the checks that allow it, with a reason. */
  overridden?: boolean;
}

/** Everything wrong with the quotation that is not about one line, blocking
 * first. An overridden check stays on the list, shown as overridden. */
export default function IssueList({ issues, overridden = false }: Props) {
  if (issues.length === 0) {
    return null;
  }
  const ordered = [...issues].sort((a, b) => (a.severity === b.severity ? 0 : a.severity === "blocking" ? -1 : 1));
  return (
    <ul className="qr-issue-list">
      {ordered.map((issue, index) => {
        const waived = overridden && issue.overridable;
        return (
          <li key={`${issue.code}-${index}`} className={`qr-issue ${waived ? "warning" : issue.severity}`}>
            <span className="qr-badge">{waived ? "overridden" : issue.severity}</span>
            <span>{issue.message}</span>
          </li>
        );
      })}
    </ul>
  );
}
